module.exports = __webpack_public_path__ + "img/guide_dir_10.47b10b9c.png";